import { useOidc } from "@axa-fr/react-oidc"
import { Button } from "@janeapp/burrito-design-system"
import { formatDate, formatPhoneNumber, fullName, parseIsoDate } from "core"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { AccountContext } from "../../context/AccountContext"
import { kcActionResult } from "../../helpers/kcActionResult"
import { AccountCard, CardError, Field } from "./AccountCard"

export const PersonalInformation = () => {
  const { login } = useOidc()
  const { t, i18n } = useTranslation()
  const { profile, loading, errors } = useContext(AccountContext)

  const dateOfBirth = profile?.dateOfBirth
    ? parseIsoDate(profile.dateOfBirth)
    : null

  const notAdded = t("loginSecurity.notAdded")

  const updateButton = (
    <Button
      onClick={() => {
        // Record the initiated action so the hub can toast on a successful return.
        kcActionResult().markPending("UPDATE_PERSONAL_INFORMATION")
        login(undefined, {
          kc_action: "UPDATE_PERSONAL_INFORMATION",
          ui_locales: i18n.language,
        })
      }}
      aria-label={t("loginSecurity.personalInformation")}
      data-testid="update-personal-information"
    >
      {t("loginSecurity.update")}
    </Button>
  )

  return (
    <AccountCard
      title={t("loginSecurity.personalInformation")}
      action={updateButton}
    >
      {errors.profile ? (
        <CardError />
      ) : (
        <>
          <Field
            label={t("loginSecurity.name")}
            value={profile ? fullName(profile) : ""}
            placeholder={notAdded}
            isLoading={loading}
          />
          <Field
            label={t("loginSecurity.preferredName")}
            value={profile?.preferredName}
            placeholder={notAdded}
            isLoading={loading}
          />
          <Field
            label={t("loginSecurity.dateOfBirth")}
            value={dateOfBirth ? formatDate(dateOfBirth, i18n.language) : ""}
            placeholder={notAdded}
            isLoading={loading}
          />
          <Field
            label={t("loginSecurity.phoneNumber")}
            value={
              profile?.phoneNumber ? formatPhoneNumber(profile.phoneNumber) : ""
            }
            placeholder={notAdded}
            isLoading={loading}
          />
        </>
      )}
    </AccountCard>
  )
}
